'use client';

import React, { useEffect, useState } from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { getUi } from '@/store/reducers/ui-slice';
import { MethodResponse, User } from '@alien-platform/bo-sdk-v2';

import { AdminTab, PlayerTab } from '@/types/general';
import { TabSwitcher } from '@/components/core/tab-switcher';

import { DetailsTab } from './details-tab';
import { JsonTab } from './json-tab';

export default function StaffDetailsContent(): React.JSX.Element | null {
  const [userData, setUserData] = useState<User | null>(null);

  const { drawerState } = useAppSelector(getUi);
  const { STAFF_DETAILS: data } = useAppSelector(getDrawerContent);
  const fetchData = async (): Promise<void> => {
    try {
      const response = await fetch(`/api/users/profile`, {
        method: 'post',
        body: JSON.stringify({ id: data?.id, opId: data?.opId }),
      });
      const result: MethodResponse<User> = await response.json();
      if (response.ok && result.success && result.data) {
        setUserData(result.data);
      }
    } catch (e) {
      // empty block
    }
  };

  useEffect(() => {
    if (drawerState.STAFF_DETAILS) void fetchData();
  }, [data]);

  const tabList = [
    {
      id: AdminTab.DETAILS,
      label: 'Details',
      content: <DetailsTab userData={userData} />,
    },
    {
      id: AdminTab.JSON,
      label: 'JSON',
      content: <JsonTab userData={userData} />,
    },
  ];

  if (!data?.id) return null;

  return <TabSwitcher tabList={tabList} />;
}
